import React, { useState } from "react";
import DrawerComponent from "../../components/Drawers/drawers";
const CreateStoreDrawer = ({
  showCreateStoreDrawer,
  setShowCreateStoreDrawer,
}) => {
  const [storeName, setStoreName] = useState("");
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [address, setAddress] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");

  const isFormComplete = storeName && state && city && address;

  const handleCreateStore = () => {
    const newStore = {
      name: storeName,
      state,
      city,
      address,
      phone: phoneNumber,
    };
    console.log("Store Created:", newStore);
    // Add logic to save store here
    setShowCreateStoreDrawer(false); // close drawer
  };

  return (
    <DrawerComponent
      show={showCreateStoreDrawer}
      showDrawer={() => setShowCreateStoreDrawer(!showCreateStoreDrawer)}
      title="Create Store"
    >
      <form
        onSubmit={(e) => {
          e.preventDefault();
          if (isFormComplete) handleCreateStore();
        }}
      >
        <div className="pt-6  mt-3 border-t border-[#E1E6E1]">
          <p className="mb-1">Name of the store</p>
          <input
            type="text"
            placeholder="Name of the store"
            className="w-full outline-none border border-[#E1E6E1] px-4 py-3 rounded-[8px] text-sm text-[#3E473F] font-semibold"
            value={storeName}
            onChange={(e) => setStoreName(e.target.value)}
          />
        </div>

        {/* State and City */}
        <div className="mt-4 flex justify-between gap-6">
          <div className="w-1/2">
            <p className="mb-1">State</p>
            <select
              className="w-full outline-none border border-[#E1E6E1] px-4 py-3 rounded-[8px] text-sm text-[#3E473F] font-semibold"
              value={state}
              onChange={(e) => setState(e.target.value)}
            >
              <option disabled value="">
                Select State
              </option>
              <option value="Lagos">Lagos</option>
              <option value="Oyo">Oyo</option>
              <option value="Abuja">Abuja</option>
              {/* Add more options */}
            </select>
          </div>
          <div className="w-1/2">
            <p className="mb-1">City</p>
            <select
              className="w-full outline-none border border-[#E1E6E1] px-4 py-3 rounded-[8px] text-sm text-[#3E473F] font-semibold"
              value={city}
              onChange={(e) => setCity(e.target.value)}
            >
              <option disabled value="">
                Select City
              </option>
              <option value="Ibadan">Ibadan</option>
              <option value="Ikeja">Ikeja</option>
              <option value="Garki">Garki</option>
              {/* Add more options */}
            </select>
          </div>
        </div>

        {/* Address */}
        <div className="mt-4">
          <p className="mb-1">Address</p>
          <input
            type="text"
            placeholder="Address"
            className="w-full outline-none border border-[#E1E6E1] px-4 py-3 rounded-[8px] text-sm text-[#3E473F] font-semibold"
            value={address}
            onChange={(e) => setAddress(e.target.value)}
          />
        </div>

        {/* Phone Number */}
        <div className="mt-4">
          <p className="mb-1">Phone Number (Optional)</p>
          <input
            type="text"
            placeholder="+234"
            className="w-full outline-none border border-[#E1E6E1] px-4 py-3 rounded-[8px] text-sm text-[#3E473F] font-semibold"
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
          />
        </div>

        {/* Submit Button */}
        <button
          type="submit"
          className={`mt-9 w-full rounded-md py-3 font-semibold ${
            isFormComplete
              ? "bg-[#2B8C34] text-white"
              : "bg-[#E1E6E1] text-white cursor-not-allowed"
          }`}
          disabled={!isFormComplete}
        >
          Create Store
        </button>
      </form>
    </DrawerComponent>
  );
};

export default CreateStoreDrawer;
